<template>
    <div class="main-page">
        <template v-if="showHeader">
            <section class="page-section mb-3" >
                <div class="container">
                    <div class="grid justify-content-between">
                        <div class="col " >
                            <div class="">
                                <div class=" text-2xl text-primary font-bold" >
                                    Add New Notifications
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
        <section class="page-section " >
            <div class="container">
                <div class="grid ">
                    <div class="md:col-9 sm:col-12 comp-grid" >
                        <div class="">
                            <div class="">
                                <div >
                                    <form ref="observer" tag="form" @submit.prevent="submitForm()" class="" :class="{ 'card': !isSubPage }">
                                        <div class="grid">
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Customer Id *
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <api-data-source   api-path="components_data/customer_id_option_list" >
                                                            <template v-slot="req">
                                                                <Dropdown class="w-full" :class="getErrorClass('customer_id')"   :loading="req.loading"   optionLabel="label" optionValue="value" ref="ctrlcustomer_id"  v-model="formData.customer_id" :options="req.response" label="Customer Id"  placeholder="Select a value ..." >
                                                                </Dropdown> 
                                                                <small v-if="isFieldValid('customer_id')" class="p-error">{{ getFieldError('customer_id') }}</small> 
                                                            </template>
                                                        </api-data-source>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Notification Type *
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlnotification_type" v-model.trim="formData.notification_type"  label="Notification Type" type="text" placeholder="Enter Notification Type"      
                                                        class=" w-full" :class="getErrorClass('notification_type')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('notification_type')" class="p-error">{{ getFieldError('notification_type') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Message 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <Textarea :class="getErrorClass('message')" class="w-full" ref="ctrlmessage" rows="5"  v-model="formData.message" placeholder="Enter Message"    type="textarea">
                                                        </Textarea>
                                                        <small v-if="isFieldValid('message')" class="p-error">{{ getFieldError('message') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Channel 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlchannel" v-model.trim="formData.channel"  label="Channel" type="text" placeholder="Enter Channel"      
                                                        class=" w-full" :class="getErrorClass('channel')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('channel')" class="p-error">{{ getFieldError('channel') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Status *
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlstatus" v-model.trim="formData.status"  label="Status" type="text" placeholder="Enter Status"      
                                                        class=" w-full" :class="getErrorClass('status')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('status')" class="p-error">{{ getFieldError('status') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="showSubmitButton" class="text-center my-3">
                                            <Button class="p-button-primary" type="submit" label="Submit" icon="pi pi-send" :loading="saving" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
	import {  computed,  reactive, toRefs, onMounted } from 'vue';
	import useVuelidate from '@vuelidate/core';
	import { required, numeric, } from '@/services/validators';
	import { useApp } from '@/composables/app.js';
	import { useAddPage } from '@/composables/addpage.js';
	const props = defineProps({
		pageName : {
			type : String,
			default : 'notifications',
		},
		routeName : {
			type : String,
			default : 'notificationsadd',
		},
		apiPath : {
			type : String,
			default : 'notifications/add',
		},
		submitButtonLabel: {
			type: String,
			default: "Submit",
		},
		formValidationError: {
			type: String,
			default: "Form is invalid",
		},
		formValidationMsg: {
			type: String,
			default: "Please complete the form",
		},
		msgAfterSave: {
			type: String,
			default: "Record added successfully",
		},
		showHeader: {
			type: Boolean,
			default: true,
		},
		showSubmitButton: {
			type: Boolean,
			default: true,
		},
		redirect: {
			type : Boolean,
			default : true,
		},
		isSubPage: {
			type : Boolean,
			default : false,
		},
		pageData: { // use to set formData default values from another page
			type: Object,
			default: () => {} 
		},
	});
	const app = useApp();
	const formDefaultValues = {
		customer_id: "", 
		notification_type: "general", 
		message: "", 
		channel: "push", 
		status: "unread", 
	};
	const formData = reactive({ ...formDefaultValues });
	//form validation rules
	const rules = computed(() => {
		return {
			customer_id: { required, numeric },
			notification_type: { required },
			message: {  },
			channel: {  },
			status: { required }
		}
	});
	const v$ = useVuelidate(rules, formData); // form validation
	const page = useAddPage({ props, formData, v$, beforeSubmit, afterSubmit });
	// perform custom validation before submit form
	// set custom form fields
	// return false if validation fails
	function beforeSubmit(){
		return true;
	}
	// after form submited to api
	// reset form data.
	// redirect to another page
	function afterSubmit(response) {
		app.flashMsg(props.msgAfterSave);
		page.setFormDefaultValues(); //reset form data
		if(props.redirect) app.navigateTo(`/notifications`);
	}
	//page state
	const {
		submitted, // form submitted state - Boolean
		saving, // form api submiting state - Boolean
		pageReady, // if api data loaded successfully
	} = toRefs(page.state);
	//page methods
	const {
		submitForm, //submit form data to api
		getErrorClass, // return error class if field is invalid- args(fieldname)
		getFieldError, //  get validation error message - args(fieldname)
		isFieldValid, // check if field is validated - args(fieldname)
		 // map api datasource  to Select options label-value
	} = page.methods;
	onMounted(()=>{
		const pageTitle = "Add New Notifications";
		app.setPageTitle(props.routeName, pageTitle); // set browser page title
	});
	// expose page object for other components access
	defineExpose({
		page
	});
</script>
<style scoped>
</style>
